export const userRoles = ["user", "processor", "admin"]
export const finapiRole = "finapi"
